import React, { useContext, useEffect } from "react";
import FilterPopup from "../FilterPopup";
import SelectableList from "../components/SelectableList";
import { FilterContext } from "../FilterContext";
import { EnvironmentFilterType, EnvironmentOption, EnvironmentOptions, initialEnvironmentFilter } from "./FilterTypes/EnvironmentFilterType";
import { areArrayValuesEqual } from "../FilterGroups/instructionUtils";

const EnvironmentFilter = () => {
  const title = "Environment";

  const { register, getValue, setInitialValue, setValue } = useContext(FilterContext);
  const reset = (): EnvironmentFilterType => initialEnvironmentFilter;
  register("environment", {
    getTitle: () => title,
    renderSelection: (value) => <>{value.options.map(o => o.label).join(", ")}</>,
    hasValue: (value) => value.options.length > 0,
    reset,
    areEqual: (a, b) => areArrayValuesEqual(a.options.map(o => o.value), b.options.map(o => o.value))
  });
  useEffect(() => {
    setInitialValue("environment", reset());
  }, []);

  const [popupOpen, setPopupOpen] = React.useState<boolean>(false);
  const [selectedOptions, setSelectedOptions] = React.useState(initialEnvironmentFilter.options);

  const onChange = (option: EnvironmentOption) => {
    setSelectedOptions([option]);
    onPopupClose();
  };

  const onPopupClose = () => {
    setValue("environment", { options: selectedOptions });
    setPopupOpen(false);
  };

  const onPopupOpen = () => {
    setSelectedOptions(getValue("environment").options);
    setPopupOpen(true);
  };

  return <div>
    <FilterPopup
      filterButtonLabel={title}
      width={272}
      content={<div>
        <SelectableList
          noSearch
          items={EnvironmentOptions}
          selectedItems={selectedOptions}
          onItemToggled={onChange}
          getId={opt => opt.value}
          getName={opt => opt.label}
        />
      </div>}

      open={popupOpen}
      onClose={onPopupClose}
      onOpen={onPopupOpen}
    />
  </div>;
};

export default EnvironmentFilter;